/* Stylesheet */

.insights_menu {
  position: relative;
  display: flex;
  height: 100%;
  width: 62px;
  justify-content: center;
  background: var(--ion-gradient-secondary);
  border-radius: 0px 12px 12px 0px;
  overflow: hidden;

  .block_container {
    .menu_button {
      margin: 0 auto;
      margin-top: 12px;
      margin-bottom: 12px;
      height: 52px;
      width: 52px;
      display: flex;
      color: #ffffff;
    }
  }
}
